/**
 * Localised URL slugs of the product lines (categories) and subcategory pages, per language, in
 * src/data/slugs.json. scripts/generate-localised-slugs.ts derives them once from the names in
 * src/translations/<lang>.json; after that the file is edited by hand and nothing derives a slug at
 * runtime. A renamed slug moves into the entry's `legacy` array, which is answered with a 301.
 */
export type SlugEntry = { slug: string; legacy: string[] };

/**
 * The URL words of the site's sections, i.e. the English literals of the route tree. Only the URL layer
 * translates them; the routes and links keep the English words.
 */
export const sectionKeys = ['categories', 'products', 'compatibility', 'blog', 'search'] as const;

export type SectionKey = (typeof sectionKeys)[number];

export type LanguageSlugs = {
  /** Hand-written per language (the generator keeps them as they are), e.g. { "search": "hledani" }. */
  sections: Record<SectionKey, string>;
  /** Keyed by category id, e.g. "1". */
  categories: Record<string, SlugEntry>;
  /** Keyed by subcategory page id, e.g. "1_3"; unique only among the subcategories of one category. */
  subcategories: Record<string, SlugEntry>;
};

export type SlugTable = Record<string, LanguageSlugs>;

/** Lower-case ASCII words joined by single hyphens. */
export const slugPattern = /^[a-z0-9]+(-[a-z0-9]+)*$/;
